



export const MenuList = [


  {
    title: "Dashboard",
    classsChange: "mm-collapse",
    iconStyle: (
      <i style={{ color: "#E5484D" }} className="flaticon-381-menu-1"></i>
    ),
    to: "/dashboard",
    permissionKey: "isDashboard"
  },

  {
    title: "Waitlist",
    classsChange: "mm-collapse",
    iconStyle: (
      <i style={{ color: "#E5484D" }} className="flaticon-381-user-2"></i>
    ),
    to: "/waitlist",
    permissionKey: "waitListManagement"
  },
  {
    title: "MIS",
    classsChange: "mm-collapse",
    iconStyle: (
      <i style={{ color: "#E5484D" }} className="flaticon-381-user-4"></i>
    ),
    to: "/user-list",
    permissionKey: "misManagement"
  },
  {
    title: "New Request",
    classsChange: "mm-collapse",
    iconStyle: (
      <i style={{ color: "#E5484D" }} className="flaticon-381-list-1"></i>
    ),
    to: "/new-request",
    permissionKey: "userManagement"
  },
  {
    title: "Deleted Accounts",
    classsChange: "mm-collapse",
    iconStyle: (
      <i style={{ color: "#E5484D" }} className="flaticon-381-list-1"></i>
    ),
    to: "/deleted-users",
    permissionKey: "deleteAccountManagement"
  },
  {
    title: "Ads Listing",
    classsChange: "mm-collapse",
    iconStyle: (
      <i style={{ color: "#E5484D" }} className="flaticon-381-note"></i>
    ),
    to: "/listings",
    permissionKey: "adsManagement"

  },
  {
    title: "Expressed Interest",
    classsChange: "mm-collapse",
    iconStyle: (
      <i style={{ color: "#E5484D" }} className="flaticon-381-note"></i>
    ),
    to: "/interested-ads",
    permissionKey: "interestedAds"

  },
  {
    title: "Safety Checks",
    classsChange: "mm-collapse",
    iconStyle: (
      <i style={{ color: "#E5484D" }} className="flaticon-381-newspaper"></i>
    ),
    to: "/safetychecks",
    permissionKey: "safetyCheckManagement"

  },
  {
    title: "Blocked Users",
    classsChange: "mm-collapse",
    iconStyle: (
      <i style={{ color: "#E5484D" }} className="flaticon-381-lock-1"></i>
    ),
    to: "/blocked-chat",
    permissionKey: "blockedUserManagement"

  },
  {
    title: "Reported Users",
    classsChange: "mm-collapse",
    iconStyle: (
      <i style={{ color: "#E5484D" }} className="flaticon-381-warning-1"></i>
    ),
    to: "/reported-chat",
    permissionKey: "reportManagement"

  },
  {
    title: "Contact Us",
    classsChange: "mm-collapse",
    iconStyle: (
      <i style={{ color: "#E5484D" }} className="flaticon-381-smartphone-1"></i>
    ),
    to: "/contact-us",
    permissionKey: "contactUsManagement"
  },
  {
    title: "Roles",
    classsChange: "mm-collapse",
    iconStyle: (
      <i style={{ color: "#E5484D" }} className="flaticon-381-record"></i>
    ),
    to: "/role",
  },
  {
    title: "Sub Admins",
    classsChange: "mm-collapse",
    iconStyle: (
      <i style={{ color: "#E5484D" }} className="flaticon-381-smartphone-1"></i>
    ),
    to: "/assign-role",
  },
  // {
  //   title: "Notification",
  //   classsChange: "mm-collapse",
  //   iconStyle: (
  //     <i style={{ color: "#E5484D" }} className="flaticon-381-notification"></i>
  //   ),
  //   to: "/notification",
  //   permissionKey: "notificationManagement"
  // },


  //  {
  //   title: "About Us",
  //   classsChange: "mm-collapse",
  //   iconStyle: (
  //     <i style={{ color: "#E5484D" }} className="flaticon-381-paperclip"></i>
  //   ),
  //   to: "/about",
  //   permissionKey: "legalPagesManagement"
  // },

  //  {
  //   title: "Terms & Condition",
  //   classsChange: "mm-collapse",
  //   iconStyle: (
  //     <i style={{ color: "#E5484D" }} className="flaticon-381-paperclip"></i>
  //   ),
  //   to: "/terms-condition",
  //   permissionKey: "legalPagesManagement"
  // },

  //   {
  //   title: "Privacy Policy",
  //   classsChange: "mm-collapse",
  //   iconStyle: (
  //     <i style={{ color: "#E5484D" }} className="flaticon-381-paperclip"></i>
  //   ),
  //   to: "/privacy-policy",
  //   permissionKey: "legalPagesManagement"
  // },





  {
    title: "Legal",
    classsChange: "mm-collapse",
    iconStyle: (
      <i style={{ color: "#E5484D" }} className="flaticon-381-paperclip"></i>
    ),
    permissionKey: "legalPagesManagement",
    content: [
      {
        title: "About Us",
        to: "/about",

      },
      {
        title: "Terms & Condition",
        to: "/terms-condition",
      },
      {
        title: "Privacy Policy",
        to: "/privacy-policy",
      }
    ]
  }
];
